// React
import { FC, memo } from "react";

// Libraries
import ReactMarkdown, { Options } from "react-markdown";

export const MessageMarkdownMemoized: FC<Options> = memo(
  ReactMarkdown,
  (prevProps, nextProps) =>
    prevProps.children === nextProps.children &&
    prevProps.className === nextProps.className
)
